<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
  @if (loading) {
    <app-spinner></app-spinner>
  }
  @if (soldout) {
    <div class="soldout">
      <p class="issue-desc">
        <fa-icon class="issue-icon" [icon]="faWarning"></fa-icon>
        This promo slot is no longer available
      </p>
      <button type="button" class="issue-action" (click)="changeDate()">Choose New Dates</button>
      <button type="button" class="issue-action" (click)="onItemRemove($event)">Remove</button>
    </div>
  }
  @if (!loading) {
    <div class="container">
      <div class="item-contents">
        <div class="image-container">
          <img [src]="itemImage">
        </div>
        <div class="item-details">
          <p class="title">{{promoStack._book?.title}}</p>
          <p>
            <span>Promo Date:</span> Starting on {{pubDate}}
          </p>
          @if (detailsExpanded) {
            <div class="expanded-details">
              <p><span>Day(s):</span> {{duration}}</p>
              <p><span>Combined Audience:</span> {{audience}}</p>
              <p><span>Book Price:</span> {{$safeNavigationMigration(promoStack?.bookPriceDuringPromo) | currency:'USD'}}</p>
              <p><span>Promo Stack:</span> {{promoStack._promoStack.name}}</p>
            </div>
          }
          <div class="edit-details">
            <a (click)="toggleDetails()">{{detailsExpanded ? 'Collapse Details' : 'Details'}}</a>
            <div class="dot">&#183;</div>
            <a (click)="editStack()">Edit</a>
          </div>
        </div>
        @if (hasValidPromoCode()) {
          <div class="price-section">
            @for (detail of discountDetails; track detail) {
              <div class="sub-section">
                <p>{{ detail.label }}</p>
                <p class="ml-10">{{ detail.value | currency:'USD' }}</p>
              </div>
            }
          </div>
        }
        <div class="flex align-items-end justify-content-end flex-direction-column">
          @if (hasSpeculativeDiscount) {
            <p class="speculative-discount-orinal-price">
              {{ promoStack._promoStack.discountedPrice | currency:'USD' }}
            </p>
          }
          <p class="total-amount">{{paymentAmount | currency:'USD'}}</p>
          @if (hasSpeculativeDiscount) {
            <div class="speculative-discount">{{ speculativeDiscountText }}</div>
          }
          @if (!hasSpeculativeDiscount && showMembershipSaving) {
            <div>
              @if (qualifiesForMembershipUpsell) {
                <div class="speculative-discount-upsell flex">
                  <div class="gold">
                    <div class="wwm-icon"></div>
                  </div>
                  {{upsellText}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
    </div>
  }
</div>
<app-confirm-modal
  [modalId]="modalId"
  [text]="confirmText"
  [buttonText]="buttonText"
  (confirmChoice)="onItemRemove($event)"
></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>

<app-modal id="promo-stack-date-picker">
  <aside class="modal">
    <div class="modal-body">
      <div class="header">
        <div class="title-text">Choose a new start date</div>
        <button class="button close" (click)="ms.close('promo-stack-date-picker')"><span class="icon">&#x00D7;</span></button>
      </div>
      <div class="content">
        <app-promo-stack-date-picker></app-promo-stack-date-picker>
      </div>
      <div class="footer">
        <button class="btn grey" (click)="ms.close('promo-stack-date-picker')">Cancel</button>
        <button class="btn btn-primary" (click)="confirmDate()">Confirm Dates</button>
      </div>
    </div>
  </aside>
</app-modal>
